import React, { useCallback, useEffect, useMemo, useState, useRef } from "react";
import Layout from "../../../../components/Layout";
import { ConfirmDelete } from "../../../../components/Alert";
import swal from "sweetalert";
import { List } from "../../../../components/_widgets/WidgetsList";
import { useAuth } from "../../../../context/ContextApi";
import { convertToSlug, getEstablishmentProducts } from "../../../../config/utils";
import api from "../../../../config/api";
import debounce from "lodash.debounce";
import styled from "styled-components";
import SearchInput from "../../../../components/inputs/SearchInput";
import AddButton from "../../../../components/buttons/AddButton";
import DrugStoreListContent from "./components/DrugStoreListContent";
import DrugStoreProductDrawer from "./components/DrugStoreProductDrawer";
import BlackWhiteButton from "../../../../components/buttons/BlackWhiteButton";
import ImportXlsxDrawer from "../components/ImportXlsxDrawer";
require("dotenv").config();
const initialProductFields = {
  _id: "",
  avatarKey: "",
  name: "",
  description: "",
  productCategory: "",
  havePrescription: false,
  sku: "",
  qty: "",
  price: "",
  discount: "",
  productPhoto: [],
};

function Product() {
  const { userToken, userId, userEstablishment, userCategory, service } = useAuth();

  const [isAddSubCategoryLoading, setIsAddSubCategoryLoading] = useState(false);
  const handleAddSubCategory = async (value) => {
    setIsAddSubCategoryLoading(true);
    try {
      await api.post("/sub-category", {
        name: value,
        slug: convertToSlug(value),
        establishment: userEstablishment,
        parent: userCategory,
      });
      getProductByEstablishment();
    } catch (e) {
      console.log(e);
    } finally {
      setIsAddSubCategoryLoading(false);
    }
  };
  const [loadBtnPhoto, setLoadBtnPhoto] = useState(false);
  const [subCategories, setSubCategories] = useState([]);
  const [productsAll, setProductsAll] = useState([]);
  const [deleteProduct, setDeleteProduct] = useState("");
  //Cadastro produto
  const [uploadImage, setUploadImage] = useState([]);
  const [imageDelete, setImageDelete] = useState([]);
  const [product, setProduct] = useState(initialProductFields);
  //error inputs
  const [erroName, setErrorName] = useState(false);
  const [erroCategory, setErrorCategory] = useState(false);
  const [erroPrice, setErrorPrice] = useState(false);
  const [erroMessage, setErrorMessage] = useState("");
  const [loadBtn, setLoadBtn] = useState(false);

  const [productList, setProductList] = useState([]);
  const [isProductListLoading, setIsProductListLoading] = useState(true);
  // Filter
  const [selectedCategoryChildren, setSelectedCategoryChildren] = useState("");
  const [nameFilter, setNameFilter] = useState("");

  // Pagination
  const [qtLimitItem, setQtLimitItem] = useState(10);
  const [pageItemsList, setPageItemsList] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const [selectedImage, setSelectedImage] = useState([]);
  const [isProductDrawerOpen, setIsProductDrawerOpen] = useState(false);

  const [variations, setVariations] = useState([]);
  const [additional, setAdditional] = useState([]);
  const [types, setTypes] = useState([]);

  const [openImportDrawer, setImportDrawer] = useState(false);

  const handleProductChange = (event) => {
    setProduct((values) => ({
      ...values,
      [event.target.name]: event.target.value,
    }));
  };

  const getProductVariations = async () => {
    try {
      const response = await api
        .get(`/product-variations?establishment=${userEstablishment}&paginate=true`)
        .then((res) => res.data.docs);
      setVariations(response);
    } catch (error) {
      console.log("Get Product Variations " + error);
    }
  };

  const getTypes = async () => {
    try {
      const response = await api.get(`/type`).then((res) => res.data);
      setTypes(response);
    } catch (error) {
      console.log("Get Types", error);
    }
  };

  const getAllProduct = useCallback(async () => {
    let res = await getEstablishmentProducts(userEstablishment);
    // console.log("res all products");
    // console.log(res);
    setTotalItems(res.total);
    setProductsAll(res.list);
  }, [userEstablishment]);

  const handleDeleteProduct = async () => {
    await api.put(`/product-update/${deleteProduct}`, { status: "inactive" });
    getAllProduct();
    getProductByEstablishment();
    swal("Sucesso!", "Produto deletado com sucesso!", "success");
  };

  const getProductByEstablishment = useCallback(async () => {
    try {
      await api
        .get(
          `/product?establishment=${userEstablishment}&paginate=true&page=${pageItemsList}&limit=${qtLimitItem}&category=${selectedCategoryChildren}&name=${nameFilter}&type=${service}`
        )
        .then((res) => {
          // setProductList(mockDrugStoreProductList);
          setProductList(res.data.docs);
          setTotalItems(res.data.total);
        });
    } catch (error) {
      console.error("Get product list", error);
    } finally {
      setIsProductListLoading(false);
    }
    await api.get(`/sub-category/${userEstablishment}`).then((res) => {
      if (res.data?.categoryChild) {
        setSubCategories(res.data.categoryChild);
      }
    });
  }, [nameFilter, pageItemsList, qtLimitItem, selectedCategoryChildren, userEstablishment]);
  // eslint needs disable for debounced react hook
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleSearch = useCallback(
    debounce((value) => search(value), 100),
    []
  );
  const search = (value) => {
    console.log(value);
    setNameFilter(value);
    setPageItemsList(1);
  };

  const selectImage = (e) => {
    if (e.target.files && e.target.files[0]) {
      updateImage(e.target.files[0]);
    }
  };
  const updateImage = (file) => {
    if (!selectedImage.length) {
      setSelectedImage([URL.createObjectURL(file)]);
    }
    setSelectedImage([...selectedImage, URL.createObjectURL(file)]);
    setUploadImage([...uploadImage, file]);
    // console.log(selectedImage);
  };

  const removeImage = async () => {
    // console.log(imageDelete);
    const index = imageDelete[0];
    const id = imageDelete[1];

    if (index > -1 && id) {
      let newProduct = product;
      // console.log(index, id);
      await api
        .put(`/product-delete-photo/${product._id}`, {
          id: id,
        })
        .then(() => {
          getAllProduct();
          getProductByEstablishment();
          newProduct.productPhoto.splice(imageDelete[0], 1);
          setProduct(newProduct);
          setImageDelete([]);
        });
    }
    if (index > -1) {
      let arrayImage = selectedImage;
      arrayImage.splice(index, 1);
      setSelectedImage([...arrayImage]);
      setUploadImage([...arrayImage]);
      setImageDelete([]);
    }
  };

  const prevButton = () => {
    if (pageItemsList !== 1) {
      setPageItemsList(pageItemsList - 1);
    }
  };

  const nextButton = () => {
    let qtPages = Math.ceil(totalItems / qtLimitItem);
    if (pageItemsList.toString() !== qtPages.toString()) {
      setPageItemsList(parseInt(pageItemsList) + 1);
    }
  };

  const changePage = (event) => {
    setPageItemsList(event.target.id);
  };

  const handleSubmitDrugStoreProduct = async (e) => {
    e.preventDefault();
    setLoadBtn(true);
    console.log("aqui");
    if (product.name === "") {
      setErrorName(true);
      setErrorMessage("* Preencha todos os campos obrigatórios");
      setLoadBtn(false);
      return false;
    }

    if (product.productCategory === "") {
      setErrorCategory(true);
      setErrorMessage("* Preencha todos os campos obrigatórios");
      setLoadBtn(false);
      return false;
    }

    if (product.price === "") {
      setErrorPrice(true);
      setErrorMessage("* Preencha todos os campos obrigatórios");
      setLoadBtn(false);
      return false;
    }

    const dataup = new FormData();
    const config = {
      headers: {
        Authorization: `Bearer ${userToken}`,
        "Content-Type": `multipart/form-data`,
      },
    };

    for (const image of uploadImage) {
      dataup.append("file", image);
    }

    console.log("submitting beauty product");
    // console.log(product);
    dataup.append("type", service);
    dataup.append("establishment", userEstablishment);
    dataup.append("havePrescription", product.havePrescription);
    product.name && dataup.append("name", product.name);
    product.description && dataup.append("description", product.description);
    product.productCategory && dataup.append("category", product.productCategory);
    product.sku && dataup.append("sku", product.sku);
    product.qty && dataup.append("qty", product.qty);
    product.price && dataup.append("price", product.price);
    product.discount && dataup.append("discount", product.discount);
    // dataup.append("file", uploadImage);
    try {
      if (product._id) {
        await editDrugStoreProduct(dataup, config);
      } else {
        const rest = await api.post(`/product`, dataup, config);
        // console.log(rest);
      }
      setLoadBtn(false);
      clearFields();
      setSelectedImage([]);
      handleProductUpdateSuccess();
      setErrorName(false);
      setErrorCategory(false);
      setErrorPrice(false);
      setErrorMessage("");
      swal("Sucesso!", "Produto cadastrado com sucesso!", "success");
    } catch (e) {
      // TODO: handle error
      setLoadBtn(false);
      console.error(e);
    }
  };

  const handleProductUpdateSuccess = () => {
    clearFields();
    setIsProductDrawerOpen(false);
    getAllProduct();
    getProductByEstablishment();
  };
  const clearFields = () => {
    setProduct(initialProductFields);
    setSelectedImage([]);
    setUploadImage([]);
  };

  const editDrugStoreProduct = async (dataup, config) => {
    const productValues = {
      name: product.name,
      description: product.description,
      category: product.productCategory,
      sku: product.sku,
      qty: product.qty,
      price: product.price,
      discount: product.discount,
      havePrescription: product.havePrescription,
      additional: product.additional,
      type: service,
    };
    try {
      if (product.avatarKey && !selectedImage) {
        await api.put(`/product-delete-photo/${product.avatarKey}`);
      } else if (selectedImage) {
        await api.put(`product-avatar/${product._id}`, dataup, config).then((resp) => console.log(resp));
      }
      await api.put(`/product-update/${product._id}`, productValues);
      setLoadBtnPhoto(false);
      handleProductUpdateSuccess();
      swal("Sucesso!", "Produto alterado com sucesso!", "success");
    } catch (e) {
      // TODO: handle error
      console.error(e);
    }
  };

  const handleAddProduct = () => {
    clearFields();
    setIsProductDrawerOpen(true);
  };

  useEffect(() => {
    getAllProduct();
    getProductByEstablishment();
    getProductVariations();
    getTypes();
  }, [getAllProduct, getProductByEstablishment]);

  const exportTable = async () => {
    const response = await api
      .get(`/products-excel/?establishment=${userEstablishment}`, { responseType: "blob" })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "report.xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <Layout defaultMenu={2} title={"Serviços"} link={""}>
        <div className="store container-fluid px-lg-1 pt-1">
          <div className="row">
            <SearchInput onChange={handleSearch} />

            <div className={`col-12 justify-content-end col-lg d-flex mb-3 ms-lg-2`}>
              <BlackWhiteButton
                className="py-2 me-4"
                onClick={() => setImportDrawer(true)}
                size={6}
                sizeLg={4}
                text="Importar planilha"
              />
              <BlackWhiteButton
                onClick={() => exportTable()}
                className=" py-2"
                size={6}
                sizeLg="auto"
                text="Exportar planilha"
              />
              <AddButton onClick={handleAddProduct} size={"auto"} className={"ms-4 py-2"} text={"Adicionar produto"} />
            </div>
          </div>
          <div className="d-flex flex-column flex-lg-row pb-4">
            <List
              section="serviços"
              onChange={(e) => setQtLimitItem(e.target.value)}
              limit={qtLimitItem}
              totalItem={totalItems}
              page={pageItemsList}
              prevButton={() => prevButton()}
              nextButton={() => nextButton()}
              changePage={(e) => changePage(e)}
            >
              <DrugStoreListContent
                {...{
                  isProductListLoading,
                  productList,
                  productsAll,
                  totalItems,
                  qtLimitItem,
                  handleSearch,
                  setDeleteProduct,
                  setProduct,
                  setIsProductDrawerOpen,
                  setSelectedCategoryChildren,
                  subCategories,
                  setSelectedImage,
                }}
              />
            </List>
          </div>
        </div>
      </Layout>
      <button
        id="btnCallConfirmDelete"
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#ConfirmDeleteProduct"
      >
        Chamar modal confirm delete
      </button>
      <ConfirmDelete
        id="confirmDeleteProduct"
        onClick={handleDeleteProduct}
        title={"Tem certeza que quer excluir este produto?"}
        text={"Excluir produto"}
      />

      <DrugStoreProductDrawer
        {...{
          erroName,
          erroCategory,
          erroPrice,
          erroMessage,
          loadBtn,
          isProductDrawerOpen,
          setIsProductDrawerOpen,
          product,
          handleProductChange,
          handleSubmitDrugStoreProduct,
          subCategories,
          isAddSubCategoryLoading,
          selectedImage,
          selectImage,
          handleAddSubCategory,
          additional,
          setAdditional,
          loadBtnPhoto,
          setImageDelete,
        }}
      />

      <ImportXlsxDrawer
        {...{
          subCategories,
          setImportDrawer,
          openImportDrawer,
          getAllProduct,
          getProductByEstablishment,
          getProductVariations,
          getTypes,
        }}
      />
      <ConfirmDelete
        id="confirmDeleteImage"
        onClick={removeImage}
        title={"Tem certeza que quer excluir esta imagem?"}
        text={"Excluir "}
      />
    </>
  );
}

export default Product;
